import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/", label: "首页", icon: "ri-home-5-line", end: true },
  { to: "/category", label: "电影", icon: "ri-film-line", end: false },
  { to: "/news", label: "资讯", icon: "ri-newspaper-line", end: false },
  { to: "/reviews", label: "影评", icon: "ri-chat-quote-line", end: false },
];

export default function MobileTabBar() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
      <div className="mx-auto grid max-w-[520px] grid-cols-4">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition ${
                isActive ? "text-primary-700" : "text-foreground-500"
              }`
            }
          >
            <span className="flex h-7 w-7 items-center justify-center rounded-full text-lg">
              <i className={tab.icon}></i>
            </span>
            {tab.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}